import React, { Suspense } from "react";
import { motion } from "framer-motion";

const CarbonOffsetEstimator = React.lazy(() => import("@/components/calculators/CarbonOffsetEstimator"));

export const CarbonOffsetEstimatorSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-[#2D7D46] mb-4 flex items-center gap-2 justify-center">
            <span role="img" aria-label="leaf">🌿</span> Carbon Offset Estimator
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Turn Impact into Data. And Data into Action.
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Suspense fallback={<div>Loading...</div>}>
            <CarbonOffsetEstimator />
          </Suspense>
        </motion.div>
      </div>
    </section>
  );
};
